import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Build the /watch path segment for an episode.
 *
 * Prefers the pretty "{slug}-{short_id}" form and falls back to the canonical
 * UUID, which the backend supports forever.  The backend resolves either form,
 * so emitting the pretty path here never breaks old links.
 *
 * Accepts the fields returned by the API (watch_path, or slug + short_id, or id).
 */
// How long after sell-out the UI shows a transient "Vyprodáno" badge before the
// founding offer disappears entirely (falls back to the regular 299 pricing).
export const FOUNDING_SOLDOUT_WINDOW_MS = 5 * 60 * 1000;

/**
 * True only in the brief window right after the last founding slot was claimed,
 * so surfaces can flash "Vyprodáno" and then drop the offer. Server-driven via
 * sold_out_at, so every visitor sees a consistent transition.
 */
export function foundingJustSoldOut(fs) {
  if (!fs || (fs.remaining ?? 0) > 0 || !fs.sold_out_at) return false;
  const t = Date.parse(fs.sold_out_at);
  return Number.isFinite(t) && (Date.now() - t) < FOUNDING_SOLDOUT_WINDOW_MS;
}

export function episodeWatchPath(ep) {
  if (!ep) return "";
  // Prefer the server's watch_path ("{slug}-{short_id}"). If only the raw fields are
  // present, build the same pretty form here. The backend resolves off the trailing
  // short_id, so a changing slug never breaks the link. Fall back to the UUID for
  // rows not yet backfilled with a short_id.
  if (ep.watch_path) return ep.watch_path;
  if (ep.short_id) return ep.slug ? `${ep.slug}-${ep.short_id}` : ep.short_id;
  return ep.id || "";
}
